import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import { api, errText } from "@/lib/api";

const HERO = "https://images.unsplash.com/photo-1766506075730-f1d871df530a?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export default function AuthPage() {
  const { login, register } = useAuth();
  const [mode, setMode] = useState("login");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [regOpen, setRegOpen] = useState(true);
  useEffect(() => {
    api.get("/settings/public").then((r) => {
      setRegOpen(r.data.registration_open);
      if (!r.data.registration_open) setMode("login");
    }).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      if (mode === "login") await login(username, password);
      else await register(username, password);
      toast.success(mode === "login" ? "С возвращением!" : "Аккаунт создан");
    } catch (err) { setError(errText(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr] bg-[#f6faf8]">
      <div className="relative hidden lg:block overflow-hidden">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0b2e20]/70" />
        <div className="relative h-full flex flex-col justify-end p-14 text-white grain">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#a3e6be]">СОР · СОЧ · 7–12 класс</p>
          <h1 className="font-display text-5xl xl:text-6xl font-extrabold leading-[1.05] mt-4 max-w-xl">Готовимся к СОР и СОЧ вместе.</h1>
          <p className="mt-5 text-lg text-white/80 max-w-md">Делитесь материалами по 11 предметам, общайтесь в сообществе и получайте по 50 коинов за каждый одобренный файл.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm rise">
          <Logo />
          <h2 className="font-display text-3xl font-bold text-[#0b2e20] mt-10">{mode === "login" ? "Вход" : "Регистрация"}</h2>
          <p className="text-sm text-[#4b6b5c] mt-2">{mode === "login" ? "Войдите по юзернейму и паролю" : "Придумайте уникальный юзернейм"}</p>
          {!regOpen && <p className="mt-6 text-sm text-[#1f5f42] bg-[#e8f5ed] rounded-xl p-3" data-testid="registration-closed-note">Регистрация сейчас закрыта. Аккаунт выдаёт администратор.</p>}
          {regOpen && <div className="mt-6 grid grid-cols-2 p-1 rounded-full bg-[#e8f5ed]">
            {[["login", "Вход"], ["register", "Регистрация"]].map(([m, l]) => (
              <button key={m} type="button" onClick={() => { setMode(m); setError(""); }} data-testid={`auth-tab-${m}`}
                className={`py-2 rounded-full text-sm font-bold transition-colors ${mode === m ? "bg-white text-[#1f5f42] shadow-sm" : "text-[#4b6b5c]"}`}>{l}</button>
            ))}
          </div>}
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="username">Юзернейм</Label>
              <Input id="username" required autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} className="h-11 bg-white" data-testid="auth-username-input" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Пароль</Label>
              <Input id="password" type="password" required autoComplete={mode === "login" ? "current-password" : "new-password"} value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 bg-white" data-testid="auth-password-input" />
            </div>
            {error && <p className="text-sm text-red-600 font-medium" data-testid="auth-error">{error}</p>}
            <Button type="submit" disabled={busy} className="w-full h-11 rounded-full bg-[#1f5f42] hover:bg-[#174731] font-bold" data-testid="auth-submit-button">
              {busy ? "Подождите..." : mode === "login" ? "Войти" : "Создать аккаунт"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
